module.exports = __webpack_public_path__ + "img/AVEVendorLogo.ee33f1d2.svg";